import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=2770ffb8&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&id=2770ffb8&lang=less&scoped=true&"
import style1 from "./Collection.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770ffb8",
  null
  
)

export default component.exports